module.exports = __webpack_public_path__ + "img/pt.34939f27.svg";